import React from 'react';
import {
  Badge,
  Button
} from 'reactstrap';
import PropTypes from 'prop-types';

const KosarItem = (props) => {
  const {
    egysegar,
    termeknev,
    mennyiseg,
    onPlusClick,
    onMinusClick,
    defaultCurrencyAzon,
    ...attrs
  } = props;
  return (
    <div className="col-sm-12 col-md-12 col-lg-12">
      <div {...attrs}>
        <b style={{ fontSize: 15 }}>{termeknev}</b>
        <div class="d-flex align-items-center" style={{ textAlign: 'left', marginBottom: 4, marginTop: 2, fontSize: 14, gap: 8 }}>
          {egysegar + ' ' + defaultCurrencyAzon + ' '}
          <Badge color="secondary" style={{ fontSize: 15 }}>{'x' + mennyiseg}</Badge>
          <span style={{ marginLeft:'auto' }}>
            {egysegar * mennyiseg + ' ' + defaultCurrencyAzon}
          </span>
        </div>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-6" style={{paddingRight: '0px'}}>
            <Button
              style={{ width: '100%', marginBottom: 16 }}
              color="success"
              onClick={onPlusClick}
            >
              {'+'}
            </Button>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6" style={{paddingLeft: '0px'}}>
            <Button
              style={{ width: '100%', marginBottom: 16 }}
              color="danger"
              onClick={onMinusClick}
            >
              {'-'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

KosarItem.propTypes = {
  onPlusClick: PropTypes.func,
  onMinusClick: PropTypes.func,
  termeknev: PropTypes.string,
  mennyiseg: PropTypes.number,
  egysegar: PropTypes.number,
};

export default KosarItem;
